// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import * as dataDict from '@/api/dataDict.js'
import * as department from '@/api/department.js'
import * as enums from '@/api/enum.js'
import * as organization from '@/api/organization.js'
import * as sysConfig from '@/api/sysConfig.js'
import * as sysMenu from '@/api/sysMenu.js'
import * as sysRole from '@/api/sysRole.js'
import * as sysTask from '@/api/sysTask.js'
import * as user from '@/api/user.js'
import * as doctor from '@/api/doctor.js'
import * as channel from '@/api/channel.js'
import * as customer from '@/api/customer.js'
import * as doctorSchedule from '@/api/doctorSchedule.js'
import * as customerMedicalRecord from '@/api/customerMedicalRecord.js'
import * as commodity from '@/api/commodity.js'
import * as order from '@/api/order.js'



Vue.prototype.$api = {
  ...dataDict, ...department, ...enums,
  ...organization, ...sysConfig, ...sysMenu,
  ...sysRole, ...sysTask, ...user, ...doctor,
  ...channel, ...customer, ...doctorSchedule,
  ...customerMedicalRecord, ...commodity, ...order
};

// vue-quill
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "./assets/quillEditor.css";


// elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.closeOnPressEscape.default = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

// vue-fragment
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)


// 时间处理
import moment from 'moment'
Vue.prototype.$moment = moment;

// xlsx解析文件
import * as XLSX from "xlsx";
Vue.prototype.$XLSX = XLSX;

// 环境变量
let envConfig = process.env;
Vue.prototype.$envConfig = envConfig;

// 自动引入处理组件插件
import componentsList from './utils/componentsRegister';
Vue.use(componentsList);

// rule
import * as ruleUtil from './utils/ruleUtil'
Vue.prototype.$ruleUtil = ruleUtil;

// storage
import * as storageUtil from './utils/storageUtil'
Vue.prototype.$storageUtil = storageUtil;

// jsTool
import * as jsTool from './utils/jsTool'
Vue.prototype.$jsTool = jsTool;

// vuex
import store from './store/index'
Vue.prototype.$store = store;


import VueQuillEditor from 'vue-quill-editor'  //引入富文本编译器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);


// axios的finally
require("promise.prototype.finally").shim();


// hasPermi指令
Vue.directive('hasPermi', {
  inserted: function (el, binding, vnode) {
    const { value } = binding
    const all_permission = "*:*:*";
    const permissions = storageUtil.getPermissions();

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
})

Vue.directive('qstype', {
  // 当绑定了指令的这个HTML元素插入到父元素上时触发(在这里父元素是 `div#app`)**.但不保证,父元素已经插入了 DOM 文档.**
  inserted: function (el, binding, vnode) {
    const { value, expression } = binding;
    if (value) {
      el.style.color = Vue.prototype.$jsTool.getColor(value);
    }
  }
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js